import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading, SecondaryButton } from './ui/UI';
const features = ['Outbound-only', 'Signed tasks', 'Local scope enforcement', 'No arbitrary shell', 'Kill switch', 'Audit logs'];
export function InternalRunnerTeaser() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-931">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-932">
        <SectionLabel number="04" label="Internal Runner" className="mb-8" data-id="element-933" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-934">
          <div className="lg:col-span-7" data-id="element-935">
            <SectionHeading size="xl" data-id="element-936">
              Inside-out validation
              <br data-id="element-937" />
              <span className="text-white/40" data-id="element-938">
                without opening the firewall.
              </span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-5 lg:pt-4" data-id="element-939">
            <p className="text-lg text-white/60 leading-relaxed mb-6" data-id="element-940">
              Deploy the Periscan Internal Runner to validate internal
              reachability, segmentation, control response, fix status, and
              internal threat paths.
            </p>
            <p className="text-lg text-white/60 leading-relaxed mb-6" data-id="element-941">
              The runner communicates outbound only, receives signed tasks,
              enforces scope locally, and returns redacted evidence.
            </p>
            <SecondaryButton href="#" size="md" data-id="element-942">
              Coming Soon
            </SecondaryButton>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-0" data-id="element-943">
          {features.map((feature, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: i * 0.04
        }} className="flex items-center gap-6 py-5 border-b border-white/5" data-id="element-944">
              <span className="font-mono text-xs text-[#1a8fd4]/60" data-id="element-945">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="text-base text-white font-medium" data-id="element-946">
                {feature}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}